import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Table } from "react-bootstrap";
import AxiosInstance from "../../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../../Services/ProjectService";
import "./ProjectDetails.css";
import { useAuth } from "../../../ProtectedRoute/AppContext";
import Multiselect from 'multiselect-react-dropdown';
import { useNavigate } from "react-router-dom";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowDropup } from "react-icons/io";
import { Description } from "@mui/icons-material";
import Loader from "../../../DesignLayout/Loader/Loader";
function ProjectDetails() {
  const navigate=useNavigate()
    const { user } = useAuth();
    const [projects, setProjects] = useState([]);
    const [status, setStatus] = useState([]);
    const [priority, setPriority] = useState([]);
    const [users, setUsers] = useState([]);
    const location = useLocation();
    const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
    const userIds = selectedAssignedTo.map((item) => item.userId).join(',');

    const [showHistory, setShowHistory] = useState(true); // State to toggle projects

const [showTasks, setshowTasks] = useState(true);
    const { projectId } = location.state || {};
  const [tasks,setTask]=useState([]);
    const date = new Date();
    const formatDateForInput = (date) => {
      const tzOffset = new Date(date).getTimezoneOffset() * 60000;
      const localISOTime = new Date(date - tzOffset).toISOString();
      return localISOTime.slice(0, 16);
    };
    const [Loading,setLoading]=useState(false);
    const [newProject, setNewProject] = useState({
      projectId: projectId,
      projectName: "",
      modifiedBy: user.userId,
      assignTo: '',
      dueDate: formatDateForInput(date),
      status: "",
      priority: "",
      description: "",
    });
  
    const [history, setHistory] = useState([]);
    const [newTask, setNewtask] = useState({
      taskName: "",
      project: projectId,
      createdBy: user.userId,
      assignedToPerson: '0',
      dueDate: formatDateForInput(date),
      status: 1,
      priority: 1,
      description: "",
      expectedDate: "",
      note:""
    });
  
    useEffect(() => {
      const fetchProjectData = async () => {
        try {
          const [
            projectResponse
          ] = await Promise.all([
            AxiosInstance.get(`${API_ENDPOINTS.GET_PROJECTS_LOADING}?projectId=${projectId}`),
           
          ]);
  
          setProjects(projectResponse.data.projects || []);
          setStatus(projectResponse.data.status || []);
          setPriority(projectResponse.data.priority || []);
          setUsers(projectResponse.data.users || []);
          setTask(projectResponse.data.tasks || []);
          setHistory(projectResponse.data.history || []);
        } catch (error) {
          console.error("Error fetching project data:", error);
          toast.error("Failed to fetch project details.");
        }
      };

      fetchProjectData();
    }, [projectId]);


  
    useEffect(() => {
      if (projects.length > 0) {
        setNewProject((prev) => ({
          ...prev,
          assignTo: projects[0]?.assignTo || "", // Ensure assignTo is always a string
        }));
      }
    
      if (projects.length > 0 && projects[0]?.assignTo && users.length > 0) {
        const assignedUserIds = projects[0].assignTo
          .split(",")
          .map(id => Number(id.trim())); // Convert ID to number
    
        const options = assignedUserIds
          .map(userId => users.find(u => Number(u.userId) === userId)) // Find users
          .filter(Boolean); // Remove null values
    
        setSelectedAssignedTo(options); // Set array of user objects
      }
    }, [projects, users]); 
    


    const [showBugSession, setShowBugSession] = useState(false); 
    const handleCreateBugClick = () => {
      setShowBugSession(true); // Show bug section
    };
  

    const onSelect = (selectedList) => {
      const selectedUserIds = selectedList.map((item) => item.userId).join(",");
      setNewProject((prev) => ({
        ...prev,
        assignTo: selectedUserIds,
      }));
    };
  const [showupdateProject, setupdateProject] = useState(false); // Track which section to show
  
    // Update this in the onClick event of the "Create Bug" button
    const handleupdateProjectClick = () => {
     
        setupdateProject(true); // Show bug section
     
     
    };
    const onRemove = (selectedList) => {
      const selectedUserIds = selectedList.map((item) => item.userId).join(",");
      setNewProject((prev) => ({
        ...prev,
        assignTo: selectedUserIds,
      }));
    };
  
    const getPriorityColor = (priority) => {
      switch (priority) {
        case "High":
        case "1":
          return "#d32121";
        case "Medium":
        case "2":
          return "#d4f004";
        case "Low":
        case "3":
          return "#04f0d1";
        case "Critical":
        case "4":
          return "#f00404";
        default:
          return "#dc3545";
      }
    };

    const updateProject = async (event) => {
      event.preventDefault();
      if (!projects || projects.length === 0) {
        toast.error("Project details are not loaded.");
        return;
      }
  
      const defaultProject = projects[0];
      const priorityData = priority.find((y) => y.name === defaultProject.priority);
      const statusData = status.find((z) => z.name === defaultProject.status);
  
      const mergedProject = {
        ...newProject,
        projectName: newProject.projectName || defaultProject.projectName,
        status: newProject.status?.toString() || statusData?.id?.toString(),
        priority: newProject.priority?.toString() || priorityData?.id?.toString(),
        dueDate: newProject.dueDate || defaultProject.dueDate,
        modifiedDate: date.toISOString(),
        assignTo: newProject.assignTo || userIds,
        description: newProject.description || defaultProject.description,
      };
  setLoading(true);
      try {
        const response = await AxiosInstance.put(
          API_ENDPOINTS.UPDATE_PROJECT,
          mergedProject
        );
  
        if (response.data) {
          const messageDuration = 2000; // Same as autoClose duration
      
          toast.success(response.data.message || "Project updated successfully.", { autoClose: messageDuration });
      
          // Navigate to projects page after toast message is shown
          setTimeout(() => {
            navigate("/projects"); // Adjust the route as per your application's routing
          }, messageDuration);
        } else {
          toast.error("Failed to update the project.");
        }
      } catch (error) {
        console.error("Error updating project:", error.response?.data || error);
        toast.error(
          error.response?.data?.title || "Failed to update. Check your inputs."
        );
      }
      finally{
        setLoading(false);
      }
    };

const handleModalClose = () => {
  setShowBugSession(false);
};
const AddTask= async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    const response = await AxiosInstance.post(API_ENDPOINTS.ADD_TASK, newTask);
    if (response.data) {
      sessionStorage.setItem("projectdMessage",response.data);
      handleModalClose();
      navigate("/projectdetails")
      //window.location.reload();
    } else {
      toast.error(response.data);
    }
  } catch (error) {
    toast.error("Invalid Task Details");
   
  }
  finally{
    setLoading(false);
  }
};
 window.onload = () => {
      const message = sessionStorage.getItem("projectdMessage");
      if (message) {
          toast.success(message);
          sessionStorage.removeItem("projectdMessage"); // Clear after showing
      }
  };
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setNewProject((prev) => ({
    ...prev,
    [name]: value || prev[name], // Ensure existing values are retained if input is empty
  }));
};




const toggleHistory = () => {
 
    setShowHistory(!showHistory);
  };


const Project_tasks=(taskId)=>{
  navigate('/taskdetails',{state:{taskId}})
}
  return (
    <div>
    <div className="border border-1">
    

      <div className="d-flex bg-info text-white p-2 align-items-center justify-content-between-center">
      <ToastContainer />
      <Loader loading={Loading} />
        <div className="col-md-6">
          <h5>Project Details</h5>
        </div>

        <div className="col-md-6 text-end">
        {user &&
    (user.permission.includes(4)===true||user.role===1 || user.role===2 )&&(
          <button className="btn btn-primary" onClick={handleCreateBugClick}>
            Create Task
          </button>
        )}
        </div>
      </div>
      {(!showBugSession && !showupdateProject) && (
        <form>
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>Project ID</th>
                <th>Project Name</th>
                <th>Started Date</th>
                 
                <th>Created By</th>
                <th>Due Date</th>
                <th>Assigned to</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project) => (
                <React.Fragment key={projects.projectId}>
                  <tr>
                    <td>PR-{project.projectId}</td>
                    <td>
                   
                    
                     {project.projectName}
                    
                    </td>
                    <td>
                    {project.createdDate}
                  </td>
                    <td>{project.createdBy}</td>
                  

                    <td>
                     
                        {new Date(newProject.dueDate).toISOString().split("T")[0] || new Date(projects[0]?.dueDate).toISOString().split("T")[0] } 
                       
                    
                    </td>

                   
                    <td>
                    
          {selectedAssignedTo.map((user) => (
    user.userName// Display userName instead of object
  )).join(", ")}
          

                    </td>

                  </tr>
                  <tr className="p-5">
                <td className="p-2"></td>
              </tr>
              <tr className="mt-5">
                    <th className="table-primary align-items-center">
                      Description
                    </th>
                    <td
                      style={{ backgroundColor: "#ebecedd7" }}
                      className=""
                      colSpan="6"
                      
                    >
                     
                     {project.description}
                       
                        <span>{project.description}</span>
                     
                    </td>
                  </tr>
                  <tr>
                  <td colSpan="7">
                 
            <button className="btn btn-warning w-100" onClick={handleupdateProjectClick}>
           Update Project
          </button>
           
          </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </form>
       )}
       {(showupdateProject) && (
        <form onSubmit={updateProject}>
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>Project ID</th>
                <th>Project Name</th>
                <th>Started Date</th>
                 
                <th>Created By</th>
                <th>Due Date</th>
                <th>Assigned to</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project) => (
                <React.Fragment key={projects.projectId}>
                  <tr>
                    <td>PR-{project.projectId}</td>
                    <td>
                    
                      <input
                        type="text"
                        value={newProject.projectName || projects[0]?.projectName || ""} // Use newtask first, fallback to default task
                        onChange={(e) =>
                          setNewProject((prev) => ({
                            ...prev,
                            projectName: e.target.value,
                          }))
                        }
                        name="taskName"
                        id="taskName" className="form-control"
                        defaultValue={project.projectName}
                      />
                  
                    </td>
                    <td>
                    {project.createdDate}
                  </td>
                    <td>{project.createdBy}</td>
                  

                    <td>
                      {/* <input type="date" name="dueDate" id="dueDate" value={newtask.dueDate} onChange={handleInputChange} defaultValue={task.dueDate} /> */}
                     
                      <input
                        type="date"
                        name="dueDate" className="form-control"
                        value={new Date(newProject.dueDate).toISOString().split("T")[0] || new Date(projects[0]?.dueDate).toISOString().split("T")[0] } // Use newtask first, fallback to default task
                        onChange={(e) =>
                          setNewProject((prev) => ({
                            ...prev,
                            dueDate: e.target.value,
                          }))
                        }
                        defaultValue={project.dueDate}
                      />
                     
                    
                    </td>

                  <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                    >
                     
             <Multiselect
                           className="multioption"
                           options={users} // Users fetched from the API
                           selectedValues={selectedAssignedTo} // Preselect assigned users
                           onSelect={onSelect} // Handle selection
                           onRemove={onRemove} // Handle removal
                           displayValue="userName" // Display the user name (ensure the property is 'name' in the users array)
                           showCheckbox={true} // Show checkboxes for multi-select
                         />

                    </td>



                  </tr>
                  <tr className="p-5">
                <td className="p-2"></td>
              </tr>
                  <tr className="mt-5">
                    <th className="table-primary align-items-center">
                      Description
                    </th>
                    <td
                      style={{ backgroundColor: "#ebecedd7" }}
                      className=""
                      colSpan="6"
                    >
                     
                      <input
                        type="text"
                        name="description"
                        id="description"
                        className="text-start form-control"
                        
                       defaultValue={project.description}
                        onChange={handleInputChange}
                      />
                     
                    </td>
                  </tr>
                  <tr>
                  <td colSpan="7">
                  {user &&
            (user.permission.includes(8)===true || user.permission.includes(10)===true||user.permission.includes(2)===true||user.role===1||user.role===2||user.role===5) && (
            <button className="btn btn-warning w-100" type="submit">
           Update Project
          </button>
            )}
          </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </form>
       )}
       {/* add task session */}
       {(showBugSession && projects.length>0) && (
        <form onSubmit={AddTask}>
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>Task Name</th>
                <th>Project Name</th>
                <th>Due Date</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    value={newTask.taskName} // Use newBug first, fallback to default bug
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        taskName: e.target.value,
                      }))
                    }
                    name="taskName"
                    id="taskName" className="form-control"
                  />
                </td>
                <td>
                 {projects[0].projectName}
                </td>

                <td>
                  <input
                    type="date"
                    name="dueDate" className="form-control"
                    value={newTask.dueDate} // Use newBug first, fallback to default bug
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        dueDate: e.target.value,
                      }))
                    }
                    defaultValue={""}
                  />
                </td>

                <td
                  style={{
                    backgroundColor: getPriorityColor(newTask.priority),
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <select
                    name="priority" className="form-control"
                    value={newTask.priority} // Use newBug first, fallback to default bug
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        priority: e.target.value,
                      }))
                    }
                  >
                    {priority.map((priorityData) => (
                      <option value={priorityData.id} key={priorityData.id}>
                        {priorityData.name}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
              <tr className="p-5">
                <td className="p-2"></td>
              </tr>
              <tr>
                <th className="thead table-primary">Assigned To</th>
                <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                    >
               <select name="assignedToPerson" value={newTask.assignedToPerson} onChange={(e)=>setNewtask({
                          ...newTask,
                          assignedToPerson:e.target.value
                        })} id="" className="form-control">
                          <option value=""> Assign to Developers </option>
                          {users.map((data)=>(
                            <option key={data.userId} value={data.userId}>{data.userName}</option>
                          ))}
                        </select>
                    </td>
                {user.role === 1 && (
                  <>
                    <th className="table-primary">Expected Date</th>
                    <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                      colSpan="2"
                    >
                      <input
                        type="date"
                        value={newTask.expectedDate}
                        name="expectedDate" className="form-control"
                        onChange={(e) =>
                          setNewtask((prev) => ({
                            ...prev,
                            expectedDate: e.target.value,
                          }))
                        }
                      />
                    </td>
                  </>
                )}
              </tr>
              <tr className="p-5">
                <td className="p-2"></td>
              </tr>
              <tr className="mt-5" style={{ height: "60px" }}>
                <th className="table-primary align-items-center">
                  Description
                </th>
                <td
                  style={{ backgroundColor: "#ebecedd7" }}
                  className=""
                  colSpan="6"
                >
                  <input
                    type="text"
                    name="description"
                    id="description"
                    className="text-start form-control"
                    value={newTask.description}
                    onChange={(e) =>
                      setNewtask((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                  />
                </td>
              </tr>
              <tr>
                
                      <td colSpan="7 ">
                        <label htmlFor="note" className="fs-5">Add Note</label>
                        <input type="text" name="note" id="note" className="w-100 p-2 form-control" value={newTask.note}  onChange={(e) =>
                            setNewtask((prev) => ({
                              ...prev,
                              note: e.target.value,
                            }))
                          } />
                      </td>
                    </tr>
            
              <tr>
                <td colSpan="7">
                  <button className="btn btn-warning w-100" type="submit">
                   Add Task
                  </button>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
       )}
      {/* closed bug session */}
    </div>
    <div className="mt-3">
      <div className="border border-1">
        <div
          className="d-flex bg-info p-2 text-white align-items-center"
          // onClick={toggleTasks}
        >
           <div className="col-md-6">
           <h5>Tasks Under Projects</h5>
        </div>

        <div className="col-md-6 text-end">
        {showTasks ?(
        <IoMdArrowDropdown size={30}/>):(

        <IoMdArrowDropup size={30}/>)}
        </div>
         
          
           
        
        </div>
        
        <div className=" tb">
          {(tasks.length>0 && user &&
    user.permission.includes(5)===true) ?(
          <Table
            striped
            bordered
            hover
            responsive
            className=" shadow-sm mt-3"
          >
            <thead className="table-primary ">
              <tr className="">
                <th>TaskId</th>
                <th>Task Name</th>
                <th>Description</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
            {tasks.map((data) => (
    <tr key={data.projectTaskId} onClick={()=>Project_tasks(data.projectTaskId)}>
      <td>{data.projectTaskId}</td>
      <td>{data.taskName}</td>
      <td>{data.description}</td>
      <td style={{
                          backgroundColor: getPriorityColor(
                            data.priority
                          ), // Use newtask.status or fallback to task.status
                          color: "white",
                          textAlign: "center",
                        }}>{data.priority}</td>
    </tr>
  ))}
            </tbody>
          </Table>
          ):(
            <div className="text-center mt-5">
              <h6>No Tasks Found</h6>
            </div>
          )}
        </div>
      
      </div>
    </div>


    <div className="mt-3">
      <div className="border border-1">
        <div
          className="d-flex bg-info p-2 text-white align-items-center"
         
          onClick={toggleHistory}
        >
          <div className="col-md-6">
           <h5>Project History</h5>
        </div>

        <div className="col-md-6 text-end">
        {showHistory ?(
        <IoMdArrowDropdown size={30}/>):(

        <IoMdArrowDropup size={30}/>)}
        </div>
        </div>
        {!showHistory &&(
        <div  >
        {history.length>0 ?(
          <Table
                       striped
                       bordered
                       hover
                       responsive
                       className=" shadow-sm mt-3"
                     >
                       <thead className="table-primary ">
                         <tr>
                           <th>Modified Date</th>
                           <th>Modified By</th>
                           <th>Updated Field</th>
                           <th>Project Name</th>
                           <th>Description</th>
                           {/* <th>Priority</th> */}
                           <th>Assigned To</th>
                           <th>Due Date</th>
                           {/* <th>Status</th> */}
                         </tr>
                       </thead>
                       <tbody>
                       {history.map((data) => (
               <tr key={data.id}>
                 <td>{new Date(data.modifiedDate).toISOString().split("T")[0]}</td>
                 <td>{data.modifiedBy}</td>
                 <td>{data.updatedFields}</td>
                 <td>{data.projectName}</td>
                 <td>{data.description}</td>
                 {/* <td style={{
                                   backgroundColor: getPriorityColor(
                                     data.priority
                                   ), // Use newtask.status or fallback to task.status
                                   color: "white",
                                   textAlign: "center",
                                 }}>{data.priority}</td> */}
                 <td>{data.assignTo}</td>
                 <td>{data.dueDate}</td>
                 {/* <td style={{
                                   backgroundColor: getStatusColor(
                                     data.status
                                   ), // Use newtask.status or fallback to task.status
                                   color: "white",
                                   textAlign: "center",
                                 }}>{data.status}</td> */}
               </tr>
             ))}
                       </tbody>
                     </Table>
          ):(
            <div className="text-center  mt-3">
              No History Found
            </div>
          )}
        </div>)}
      </div>
    </div>
  </div>
  )
}

export default ProjectDetails
 